// 「切换节点」偏好:纯前端 localStorage 缓存,不写 profiles(D23 作废)。
// 设计:docs/superpowers/specs/2026-07-13-resource-node-switch-client-design.md §3.1
// domain=null 表示「自动」= 用当前访问域名(相对路径,不加前缀)。

export type NodePref = {
  node_id: string
  domain: string | null
  tested_at: number
}

const KEY = 'dd_resource_node'
/** 6h:超过即 stale,自动测速覆盖(含手动选择;owner 决策「总是覆盖」) */
export const STALE_MS = 6 * 3_600_000

let cached: NodePref | null = null
let loaded = false
const listeners = new Set<() => void>()

function parse(raw: string | null): NodePref | null {
  if (!raw) return null
  try {
    const v = JSON.parse(raw) as Partial<NodePref>
    if (typeof v.node_id !== 'string' || typeof v.tested_at !== 'number') return null
    if (v.domain !== null && typeof v.domain !== 'string') return null
    return { node_id: v.node_id, domain: v.domain ?? null, tested_at: v.tested_at }
  } catch {
    return null
  }
}

function notify(): void {
  listeners.forEach((cb) => cb())
}

export function getPref(): NodePref | null {
  if (!loaded) {
    cached = typeof localStorage === 'undefined' ? null : parse(localStorage.getItem(KEY))
    loaded = true
  }
  return cached
}

export function setPref(p: NodePref): void {
  cached = p
  loaded = true
  try {
    localStorage.setItem(KEY, JSON.stringify(p))
  } catch {
    // 隐私模式等写失败:仅内存生效,刷新后回自动档
  }
  notify()
}

export function clearToAuto(now: number = Date.now()): void {
  setPref({ node_id: 'auto', domain: null, tested_at: now })
}

export function subscribe(cb: () => void): () => void {
  listeners.add(cb)
  return () => {
    listeners.delete(cb)
  }
}

export function isStale(now: number = Date.now()): boolean {
  const p = getPref()
  return !p || now - p.tested_at >= STALE_MS
}

const PREFIXES = ['/gapi/file/', '/imgp/']

/** 字节路径改写:选中域名非空且命中公开字节前缀 → 拼绝对 URL;其余原样(幂等不双拼) */
export function resourceUrl(path: string): string {
  const p = getPref()
  if (!p?.domain) return path
  if (!PREFIXES.some((pre) => path.startsWith(pre))) return path
  return `https://${p.domain}${path}`
}

// 跨 tab 同步:另一 tab 改写 localStorage 时失效内存缓存并通知
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key !== KEY) return
    cached = parse(e.newValue)
    loaded = true
    notify()
  })
}

/** 仅测试用:清内存缓存与订阅(不动 localStorage) */
export function __resetForTest(): void {
  cached = null
  loaded = false
  listeners.clear()
}
